import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/calorimetry-calculator',
  component: () => import('../../routes/CalorimetryCalculator.svelte'),
  card: {
    id: 'calorimetry-calculator',
    title: 'Calorimetry Calculator',
    description:
      'Solve calorimetry problems with sensible heat (Q = m·c·ΔT), latent heat (Q = m·L), and mixing equilibrium. Includes 25+ substance presets (water, copper, ice, steam, metals).',
    icon: 'whatshot',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/calorimetry-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Calorimetry Calculator – Q = m·c·ΔT and Q = m·L Solved',
    description:
      'Free calorimetry calculator with 4 solve modes: heat energy (sensible), final temperature, latent heat (phase change), and mixing equilibrium. 25+ substance presets including water, copper, iron, aluminum, ice, and steam.',
  },
};

export default meta;
